import angular from 'angular';
import template from './scheduling-dashboard.html';
import SchedulingDashboardController from './scheduling-dashboard.controller';
import SchedulingDashboardDirective from './SchedulingDashboard.module';

function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state('drivecoach.admin.schedulingdashboard', {
        url: '/scheduling-dashboard',
        controller: SchedulingDashboardController,
        controllerAs: 'vm',
        template: template,
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner
            ]
        }
    });
}
config.$inject = ['$stateProvider', '$urlRouterProvider', 'USER_ROLES'];

export default angular
    .module('admin.schedulingdashboard', [SchedulingDashboardDirective.name])
    .config(config)
    .controller('SchedulingDashboardController', SchedulingDashboardController);
